import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { AppError } from "../../../app-error/app-error.model";

import { MULTI_DEPOSIT_LIMIT_ACTION_TYPE } from "./multi-deposit-limit.action";
import { MULTI_DEPOSIT_LIMIT_MESSAGE_CODES } from "./multi-deposit-limit.const";
import { MultiDepositLimitState } from "./multi-deposit-limit.model";

const INITIAL_STATE: MultiDepositLimitState = {};

export function multiDepositLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): MultiDepositLimitState {
	switch (action.type) {
		case MULTI_DEPOSIT_LIMIT_ACTION_TYPE.getSuccess:
			return updateState(state, {
				multiDepositLimits: action.payload,
				limitsNotFoundError: undefined,
			});
		case MULTI_DEPOSIT_LIMIT_ACTION_TYPE.updateSuccess:
			if (action.payload) {
				return updateState(state, {
					multiDepositLimits: action.payload,
					limitsNotFoundError: undefined,
				});
			}

			return state;
		case MULTI_DEPOSIT_LIMIT_ACTION_TYPE.getFail: {
			const payload = action.payload as AppError;

			if (payload.code === MULTI_DEPOSIT_LIMIT_MESSAGE_CODES.limitNotFound) {
				return updateState(state, {
					limitsNotFoundError: true,
				});
			}

			return updateState(state, {
				limitsNotFoundError: false,
			});
		}
		case MULTI_DEPOSIT_LIMIT_ACTION_TYPE.clear: {
			return INITIAL_STATE;
		}
		default:
			return state;
	}
}
